module.exports = __webpack_public_path__ + "img/03-thumbnail.09c41872.jpg";